<div style="padding: 0rem 3rem;">
  <!-- <app-back-page (backAction)="backToMainPage($event)"></app-back-page> -->
  <div id="form-container">
    <form (submit)="onFormSubmit($event)">
      <dx-form labelMode="floating" labelLocation="top" id="form" [(formData)]="employeeDuration" [colCount]="12" [showColonAfterLabel]="true"
        [showValidationSummary]="true" validationGroup="customerData">


     <dxi-item dataField="employeeIds" [colSpan]="12">            
              <dx-drop-down-box [(value)]="selectedEmployee" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                valueExpr="employeeId" displayExpr="employeeNameAr" [showClearButton]="true"
                placeholder="{{'choose'|translate}}  {{'hr.employeeId' | translate}}"
                [dataSource]="employeeinformation" contentTemplate="employeeContentTemplate">
                <div *dxTemplate="let e of 'employeeContentTemplate'" style="overflow-x: auto;">
                  <dxo-label text="{{'hr.employeeId' | translate}}"></dxo-label>
                  <dx-data-grid [dataSource]="employeeinformation" keyExpr="employeeId" [remoteOperations]="true"
                    [height]="300" [selectedRowKeys]="selectedEmployee" [focusedRowEnabled]="true"
                    [searchPanel]="{ visible: true, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                    (onSelectionChanged)="onEmployeeSelectionChanged($event.selectedRowKeys)"
                    [columnAutoWidth]="true"    
                    [wordWrapEnabled]="false"   
                    [width]="'100%'" 
                    [columns]="filteredEmployeeColumns">
                    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                    <dxo-scrolling 
                      mode="virtual"
                      showScrollbar="always"
                    ></dxo-scrolling>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </dxi-item>

 <dxi-item dataField="branchIds" [colSpan]="4" style="margin-top: 10px;">                              
                <dx-drop-down-box [(value)]="selectedBranch" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                  valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="branchesdropdown"
                  placeholder="{{'choose'| translate}}  {{'basic-info.branch.branchName' | translate}}"
                  contentTemplate="branchContentTemplate" >
                  <!-- <dxo-label text="{{'basic-info.branch.branchName' | translate}}"></dxo-label> -->
                  <div *dxTemplate="let e of 'branchContentTemplate'">
                    <dxo-label text="{{'basic-info.branch.branchName' | translate}}"></dxo-label>
                    <dx-data-grid [dataSource]="branchesdropdown" keyExpr="id" [remoteOperations]="true" [height]="500"
                      [selectedRowKeys]="selectedBranch" [focusedRowEnabled]="true"
                      [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                      (onSelectionChanged)="onBranchSelectionChanged($event.selectedRowKeys)"
                      [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('basic-info.branch.branchName')}]">
                      <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                      <dxo-scrolling mode="virtual"></dxo-scrolling>
                      <dxo-selection mode="multiple"></dxo-selection>
                      <dxo-filter-row [visible]="true"></dxo-filter-row>
                      <dxo-header-filter [visible]="true"></dxo-header-filter>
                    </dx-data-grid>
                  </div>
                </dx-drop-down-box>
              </dxi-item>


            
            <dxi-item dataField="jobTitleIds" [colSpan]="4" style="margin-top: 10px;">
              <dx-drop-down-box [(value)]="selectedJob" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="jobTitleDropDown"
                placeholder="{{'choose'| translate}}  {{'salary.jobTitleId' | translate}} "
                contentTemplate="jobContentTemplate">
                <div *dxTemplate="let e of 'jobContentTemplate'">
                  <dxo-label template="{{'salary.jobTitleId' | translate}}"></dxo-label>
                  <dx-data-grid [dataSource]="jobTitleDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
                    [selectedRowKeys]="selectedJob" [focusedRowEnabled]="true"
                    [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                    (onSelectionChanged)="onJobTitleSelectionChanged($event.selectedRowKeys)"
                    [columns]="[{ dataField: 'nameAr', caption:this.translate.instant('salary.jobTitleId') }]">
                    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </dxi-item>

          <dxi-item dataField="managementIds" [colSpan]="4" style="margin-top: 10px;">            
              <dx-drop-down-box [(value)]="selectedManagement" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="managementDropDown"
                placeholder="{{'choose'|translate}}  {{'salary.management' | translate}}"
                contentTemplate="managementContentTemplate">
                <div *dxTemplate="let e of 'managementContentTemplate'">
                  <dxo-label template="{{'salary.management' | translate}}"></dxo-label>
                  <dx-data-grid [dataSource]="managementDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
                    [selectedRowKeys]="selectedManagement" [focusedRowEnabled]="true"
                    [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                    (onSelectionChanged)="onManagementSelectionChanged($event.selectedRowKeys)"
                    [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('salary.management') }]">
                    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </dxi-item>


          <dxi-item dataField="departmentIds" [colSpan]="4" style="margin-top: 10px;">
       
            
              <dx-drop-down-box [(value)]="selectedDepartment" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="departmentDropDown"
                placeholder="{{'choose'| translate}}  {{'salary.department' | translate}}"
                contentTemplate="departmentContentTemplate">
                <div *dxTemplate="let e of 'departmentContentTemplate'">
                  <dxo-label template="{{'salary.department' | translate}}"></dxo-label>
                  <dx-data-grid [dataSource]="departmentDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
                    [selectedRowKeys]="selectedDepartment" [focusedRowEnabled]="true"
                    [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                    (onSelectionChanged)="onDepartmentSelectionChanged($event.selectedRowKeys)"
                    [columns]="[{ dataField: 'nameAr', caption:this.translate.instant('salary.department')  }]">
                    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </dxi-item>


          <dxi-item dataField="workSystemIds" [colSpan]="4" style="margin-top: 10px;">
            <!-- Employee Data Grid inside DropDownBox -->            
              <dx-drop-down-box [(value)]="selectedWorkSystem" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="WorkSystemDropDown"
                placeholder="{{'choose'|translate}} {{'salary.workSystem' | translate}}"
                contentTemplate="WorkSystemContentTemplate">
                <div *dxTemplate="let e of 'WorkSystemContentTemplate'">
                  <dxo-label template="{{'salary.workSystem' | translate}}"></dxo-label>
                  <dx-data-grid [dataSource]="WorkSystemDropDown" keyExpr="id" [remoteOperations]="true" [height]="500"
                    [selectedRowKeys]="selectedWorkSystem" [focusedRowEnabled]="true"
                    [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                    (onSelectionChanged)="onWorkSystemSelectionChanged($event.selectedRowKeys)"
                    [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('salary.workSystem') }]">
                    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </dxi-item>



            <dxi-item dataField="WorkDurationIds" [colSpan]="4" style="margin-top: 10px;">                              
                <dx-drop-down-box [(value)]="selectedWorkDurations" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                  valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="workDataSource"
                  placeholder="{{'choose'| translate}}  {{'employeeduration.SelectWorkDuration' | translate}}"
                  contentTemplate="WorkDurationContentTemplate" >
                  <!-- <dxo-label text="{{'basic-info.branch.branchName' | translate}}"></dxo-label> -->
                  <div *dxTemplate="let e of 'WorkDurationContentTemplate'">
                    <dxo-label text="{{'employeeduration.SelectWorkDuration' | translate}}"></dxo-label>
                    <dx-data-grid [dataSource]="workDataSource" keyExpr="id" [remoteOperations]="true" [height]="500"
                      [selectedRowKeys]="selectedWorkDurations" [focusedRowEnabled]="true"
                      [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                      (onSelectionChanged)="onWorkDurationChanged($event.selectedRowKeys)"
                      [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('employeeduration.SelectWorkDuration')}]">
                      <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                      <dxo-scrolling mode="virtual"></dxo-scrolling>
                      <dxo-selection mode="multiple"></dxo-selection>
                      <dxo-filter-row [visible]="true"></dxo-filter-row>
                      <dxo-header-filter [visible]="true"></dxo-header-filter>
                    </dx-data-grid>
                  </div>
                </dx-drop-down-box>
              </dxi-item>

    <dxi-item dataField="breakDurationIds" [colSpan]="4" style="margin-top: 10px;">                              
                <dx-drop-down-box [(value)]="selectedBreaks" [inputAttr]="{ 'aria-label': 'Employee Information' }"
                  valueExpr="id" displayExpr="nameAr" [showClearButton]="true" [dataSource]="breakDataSource"
                  placeholder="{{'choose'| translate}}  {{'employeeduration.SelectBreak' | translate}}"
                  contentTemplate="breakDurationContentTemplate" >
                  <!-- <dxo-label text="{{'basic-info.branch.branchName' | translate}}"></dxo-label> -->
                  <div *dxTemplate="let e of 'breakDurationContentTemplate'">
                    <dxo-label text="{{'employeeduration.SelectBreak' | translate}}"></dxo-label>
                    <dx-data-grid [dataSource]="breakDataSource" keyExpr="id" [remoteOperations]="true" [height]="500"
                      [selectedRowKeys]="selectedBreaks" [focusedRowEnabled]="true"
                      [searchPanel]="{ visible: true, width: 300, placeholder: 'Search...' }" [hoverStateEnabled]="true"
                      (onSelectionChanged)="onBreakDurationChanged($event.selectedRowKeys)"
                      [columns]="[{ dataField: 'nameAr', caption: this.translate.instant('employeeduration.SelectBreak')}]">
                      <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                      <dxo-scrolling mode="virtual"></dxo-scrolling>
                      <dxo-selection mode="multiple"></dxo-selection>
                      <dxo-filter-row [visible]="true"></dxo-filter-row>
                      <dxo-header-filter [visible]="true"></dxo-header-filter>
                    </dx-data-grid>
                  </div>
                </dx-drop-down-box>
              </dxi-item>

          <dxi-item dataField="salaryNotes" [colSpan]="4">
            <dxo-label text="{{'salary.salaryNotes'|translate}}"></dxo-label>
            <dxi-validation-rule message="{{'errors.namerequired'|translate}}"></dxi-validation-rule>            
          </dxi-item>

          <dxi-item dataField="bankId" editorType="dxLookup" [colSpan]="4"
            [editorOptions]="{dataSource: bankDropDown, displayExpr: 'nameAr', valueExpr: 'id', searchEnabled: true, showClearButton: true}">

            <dxo-label text="{{'salary.bank' | translate}}"></dxo-label>
          </dxi-item>


          
          



        <dxi-item editorType="dxDateBox" [colSpan]="4" dataField="from">
          <dxo-label location="top" text="{{'tableinfo.from'|translate}}"></dxo-label>
          <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
        </dxi-item>


        <dxi-item editorType="dxDateBox" [colSpan]="4" dataField="to">
          <dxo-label location="top" text="{{'tableinfo.to'|translate}}"></dxo-label>
          <dxi-validation-rule type="required" message="{{'errors.required'|translate}}"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="employeeDuration.from"
            message="{{'errors.greater'|translate}}"></dxi-validation-rule>
        </dxi-item>


        <dxi-item [colSpan]="4" style="margin-top: 10px;">
          <dxo-label location="top" text="{{'employeeduration.employee'|translate}}"></dxo-label>
       <app-dropdown [m]="weekDataSource" [value]="vacationvalue" 
              [coulmn]="Vacationarray" 
              (valueChange)="onholidayChanged($event)"></app-dropdown>
        </dxi-item>


        
       <dxi-item 
  style="margin-top: 10px;" 
  [colSpan]="2" 
  itemType="button" 
  [buttonOptions]="buttonOptions">
</dxi-item>

<dxi-item [colSpan]="2" style="margin-top: 10px;">
  <div *dxTemplate>
    <dx-button 
      type="success" 
      icon="check"
      style="width: 100%;"
      stylingMode="outlined"
      text="{{'تطبيق التعديل الجزئي' | translate}}"
      (onClick)="applyOverrideFromMainInputs()">
    </dx-button>
  </div>
</dxi-item>


        <dxi-item style="margin-top: 10px;" [colSpan]="2" >
        <dxi-item [colSpan]="4" style="margin-top: 10px;">
          <dxo-label location="top" text="{{'employeeduration.SelectBreak'|translate}}"></dxo-label>
          <app-dropdown [m]="breakDataSource" [value]="breakvalue" [coulmn]="Holidayarray" (valueChange)="onBreakChanged($event)" [selectionmode]="'single'"></app-dropdown>
        </dxi-item>

        <dxi-item [colSpan]="4" style="margin-top: 10px;margin-bottom: 10px;">
          <dxo-label location="top" text="{{'employeeduration.SelectWorkDuration'|translate}}"></dxo-label>
          <app-dropdown [m]="workDataSource" [value]="workvalue" [coulmn]="Holidayarray" (valueChange)="onholidayChanged($event)" [selectionmode]="'single'"></app-dropdown>
        </dxi-item>


        <dxi-item [colSpan]="2" itemType="button" [buttonOptions]="buttonOptions">
        </dxi-item>


        <dxi-item style="margin-top: 10px;" [colSpan]="2">
          <dx-button type="default" stylingMode="outlined"
            (onClick)="passdatatoallrows()">{{'employeeduration.makesamedata'|translate}}</dx-button>
        </dxi-item>

        
  

</dxi-item>
</dx-form>
    </form>
  </div>

 <dx-data-grid 
  style="margin-top: 20px;" 
  [dataSource]="tablelist" 
  [showBorders]="false" 
  [columnAutoWidth]="true" 
  [columnHidingEnabled]="true"
  [showColumnLines]="false" 
  [rowAlternationEnabled]="true" 
  [showRowLines]="false" 
  [showBorders]="false"
  (onEditorPreparing)="onEditorPreparing($event)" 
  (onCellPrepared)="onCellPrepared($event)"
  (onRowUpdated)="onRowUpdated($event)"
  (onCellValueChanged)="onCellValueChanged($event)">
<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
    <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>

    <dxi-column dataField="id" [visible]="false">
    </dxi-column>
    <dxi-column [visible]="false" dataField="employeeId" caption="{{'employeeduration.employee'|translate}}">
      <dxo-lookup [dataSource]="employeedropdown" valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
    </dxi-column>
        <dxi-column dataField="employeeName" caption="{{'tableinfo.employee'|translate}}">
    </dxi-column>
    <dxi-column dataField="dateTimeRegister" dataType="date" cssClass="cell-highlighted"
      caption="{{'tableinfo.dateOfRegistration'|translate}}">
    </dxi-column>

    <dxi-column dataField="vacation" dataType="boolean" caption="{{'worksystem.vacations'|translate}}">
    </dxi-column>

   <dxi-column 
    dataField="durationWorkSystemEmployeesArray" 
    cellTemplate="tagBoxTemplate"
    caption="{{'employeeduration.WorkDuration'|translate}}">
</dxi-column>

<div *dxTemplate="let cellInfo of 'tagBoxTemplate'">
    <dx-tag-box
        [value]="cellInfo.value"
        valueExpr="id"
        displayExpr="nameAr"
        [dataSource]="durationworkdropdown"
        [showSelectionControls]="true"
        (onValueChanged)="onWorkSystemChanged($event, cellInfo)">
    </dx-tag-box>
</div>



    <dxi-column dataField="durationWorkSystemEmployeeBreaksArray" cellTemplate="tagBoxTemplate2"
      caption="{{'employeeduration.breakDuration'|translate}}"></dxi-column>


    <div *dxTemplate="let cellInfo of 'tagBoxTemplate2'">
      <dx-tag-box [value]="cellInfo.value" valueExpr="id" displayExpr="nameAr" [dataSource]="breakdropdown"
       ></dx-tag-box>
    </div>
  </dx-data-grid>

<dx-button
  text="{{ 'employeeduration.submit' | translate }}"
  stylingMode="outlined"
  type="default"
  
  [useSubmitBehavior]="false"
  (onClick)="submit($event)"
  style="margin: 1rem; width: 10rem; display: flex; float: left;"
>
</dx-button>



  

</div>


